/**
 * Polyfills for older browser compatibility
 * These polyfills help support Android devices from around 2019-2020
 */

// Promise.allSettled polyfill for older browsers
if (!Promise.allSettled) {
  Promise.allSettled = function(promises) {
    return Promise.all(
      promises.map(p => 
        Promise.resolve(p)
          .then(value => ({ status: 'fulfilled', value }))
          .catch(reason => ({ status: 'rejected', reason }))
      )
    );
  };
}

// Object.fromEntries polyfill
if (!Object.fromEntries) {
  Object.fromEntries = function(entries) {
    if (!entries || !entries[Symbol.iterator]) {
      throw new Error('Object.fromEntries requires an iterable object');
    }
    return [...entries].reduce((obj, [key, val]) => {
      obj[key] = val;
      return obj;
    }, {});
  };
}

// String.prototype.replaceAll polyfill
if (!String.prototype.replaceAll) {
  String.prototype.replaceAll = function(pattern, replacement) {
    return this.split(pattern).join(replacement);
  };
}

// Array.prototype.at polyfill
if (!Array.prototype.at) {
  Array.prototype.at = function(index) {
    return this[index < 0 ? this.length + index : index];
  };
}

// Element.prototype.toggleAttribute polyfill
if (!Element.prototype.toggleAttribute) {
  Element.prototype.toggleAttribute = function(name, force) {
    if (force !== undefined) {
      force ? this.setAttribute(name, '') : this.removeAttribute(name);
      return force;
    }
    if (this.hasAttribute(name)) {
      this.removeAttribute(name);
      return false;
    }
    this.setAttribute(name, '');
    return true;
  };
}

// AbortController polyfill stub - for older browsers that might not support it
if (typeof window !== 'undefined' && !window.AbortController) {
  window.AbortController = function() {
    this.signal = {
      aborted: false,
      addEventListener: function() {},
      removeEventListener: function() {},
      dispatchEvent: function() { return false; }
    };
    this.abort = function() {
      this.signal.aborted = true;
    };
  };
}

console.log('Polyfills loaded for older browser compatibility');
